const types = {
  ALL_CLIENTES: "@clientes/ALL",
  UPDATE_CLIENTE: "@clientes/UPDATE",
  UPDATE_DATA_CLIENTE: "@cliente/UPDATEDATACLIENTE",
  UPDATE_CNH_CLIENTE: "@cliente/UPDATECNHCLIENTE",
  FILTER_CLIENTES: "@cliente/FILTER",
  FILTER_CLIENTES_CNH: "@cliente/CNH",
 ADD_CLIENTES: "@cliente/ADD",
 ADD_STEP_CODE_INSERT: "@cliente/Code",
 ADD_CLIENTES_TWO: "@clienteTwo/TWO",
  RESET_CLIENTES: "@cliente/RESET",
  RESET_STEP1: "@step1/RESET",
  RESET_STEP2: "@step2/RESET",
  UNLINK_CLIENTES: "@cliente/UNLINK",
  LOGIN_SESSION_IN: "@cliente/LOGIN",
  LOGIN_SESSION_OUT: "@cliente/LOGOUT",
};

export default types;
